import React, { Suspense } from 'react';
import { useBreakpoint, Nav, Progress } from '@landr/maestro';
import { FeedbackModalProvider, useFeedbackModal } from '../NavBarFeedbackModal/FeedbackModalProvider.es.js';
import { LibraryIcon } from './components/LibraryIcon.es.js';
import { NavBarHelp } from '../NavBarHelp/NavBarHelp.es.js';
import { NavBarAuth } from '../NavBarAuth/NavBarAuth.es.js';
import { NavBarUserMenu } from '../NavBarUserMenu/NavBarUserMenu.es.js';
import { FeedbackModal } from '../NavBarFeedbackModal/FeedbackModal.es.js';
import { useNavBarContext } from '../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { NavBarSearch } from '../NavBarSearch/NavBarSearch.es.js';

var NavBarMessages = React.lazy(function () {
  return import('../NavBarMessages/index.es.js').then(function (module) {
    return {
      "default": module.NavBarMessages
    };
  });
});
var NavBarNotificationFeed = React.lazy(function () {
  return import('../NavBarNotificationFeed/index.es.js').then(function (module) {
    return {
      "default": module.NavBarNotificationFeed
    };
  });
});
var NavBarSessionsPicker = React.lazy(function () {
  return import('../NavBarSessionsPicker/index.es.js').then(function (module) {
    return {
      "default": module.NavBarSessionsPicker
    };
  });
});
var NavBarSideNav = function NavBarSideNav() {
  var _useNavBarContext = useNavBarContext(),
    user = _useNavBarContext.user,
    isUserLoading = _useNavBarContext.isUserLoading,
    hasNotifications = _useNavBarContext.hasNotifications,
    isSessionsPickerVisible = _useNavBarContext.isSessionsPickerVisible;
  var _useFeedbackModal = useFeedbackModal(),
    isModalOpen = _useFeedbackModal.isModalOpen,
    closeModal = _useFeedbackModal.closeModal;
  var isMobile = useBreakpoint('md');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    ml: "auto"
  }, user && /*#__PURE__*/React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(NavBarSearch, null)), !isMobile && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(LibraryIcon, null)), isSessionsPickerVisible && !isMobile && /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(NavBarSessionsPicker, null)), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(NavBarMessages, null))), hasNotifications && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(NavBarNotificationFeed, null)))), user === null && !isUserLoading && /*#__PURE__*/React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(NavBarHelp, null)), /*#__PURE__*/React.createElement(NavBarAuth, null)), !user && isUserLoading && /*#__PURE__*/React.createElement(Progress, {
    "data-testid": "spinner-user-loading"
  }), user && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(NavBarUserMenu, null))), /*#__PURE__*/React.createElement(FeedbackModal, {
    isModalOpen: isModalOpen,
    onModalClose: closeModal
  }));
};
var WithProviders = function WithProviders() {
  return /*#__PURE__*/React.createElement(FeedbackModalProvider, null, /*#__PURE__*/React.createElement(NavBarSideNav, null));
};
var NavBarSideNav$1 = WithProviders;

export { NavBarSideNav, NavBarSideNav$1 as default };
